export enum FeeAmountFlags {
    Maintain = '*',
    Replace = '#',
    AddOrSubtract = '+',
    Percentage = '%',
    Clear = '_'
};
export enum ParameterNames {
    Practice = 1,
    FinancialClass = 2,
    Payer = 3,
    BillingProvider = 4,
    ServiceLocation = 5
};
export enum FeeFlagType {
    feeFlag = 1,
    allowedFlag = 2,
    inHouseFlag = 3,
    taxFlag = 4,
    rvuFlag= 5
};
export enum FeeType {
    FlatFee = "F",
    PerUnitFee = "P"
};
export interface IFeePractice {
    usePractice: boolean,
    practiceID: number
}
export interface INegFeeImportSchedule {
    StartDate: string,
    PracticeId: number,
    FinancialClassId: number,
    PayerId: number,
    BillingProviderId: number,
    ServiceLocationId: number, 
    FeeFlag: FeeAmountFlags,
    FeePerUnit?: number,
    AllowedFlag: FeeAmountFlags,
    AllowedAmount?: number,
    InHouseFlag: FeeAmountFlags,
    InHouseCost?: number, 
    TaxFlag: FeeAmountFlags,
    TaxAmount?: number,
    RvuFlag: FeeAmountFlags,
    RvuAmount?: number
};
export interface INegFeeImportFile {
    procedureCode?: string,
    feeType?: string,
    feePerUnit?: number,
    allowedAmount?: number,
    inHouseCost?: number,
    taxAmount?: number,
    rvuAmount?: number,
    baseUnits?: string,
    feeMessage?: string
};
export interface ICodeValidation {
    RequiredModifiers: boolean,
    RestrictedModifiers: boolean,
    RequiredProcedures: boolean,
    RestrictedProcedures: boolean,
    RequiredDiagnoses: boolean,
    RestrictedDiagnoses: boolean,
    RequiredPrimaryDiagnoses: boolean,
    RestrictedPrimaryDiagnoses: boolean
};
export interface INegFeeStatus {
    errorCode: boolean,
    feeMessage: string,
    validRecordCount: number,
    invalidRecordCount: number,
};
export interface INegFeeImport {
    FileName: string,
    ValidationData : ICodeValidation[],
    ScheduleData: INegFeeImportSchedule[],
    DataFile: INegFeeImportFile[]
};
export interface INegFeeResponse {
    feeStatus: INegFeeStatus,
    dataFile: INegFeeImportFile[]
};